import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'antd'
import Calendar from 'react-calendar';
import ModalReservationVroom from './ModalReservationVroom'
import moment from 'moment'
import ModalJoinVroom from './ModalJoinVroom';
import { useDispatch } from 'react-redux'
import { SET_RESERVATION, GET_RESERVATION, GET_ROOM_DAY } from '../../redux/actions/type'
import { checkTokenExpire } from '../../redux/actions/actions'
import { translate } from 'react-i18next'


const ContentLeft = ({
    language,
    reservationList,
    reservationItems,
    activeItem,
    calendarDate,
    t
}) => {
    const momentDateNow = moment(moment().format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm')
    const [createReservation, setReservation] = useState({
        visible: false,
        action: null
    })
    const [jointVroom, setJointVroom] = useState(false)
    const [calendarDateState, setCalendarDateState] = useState(calendarDate)
    const [calendarSelect, setcalendarSelect] = useState(momentDateNow)
    const dispatch = useDispatch()

    useEffect(() => {
        if (calendarDateState !== calendarDate) {
            dispatch({
                type: SET_RESERVATION,
                payload: {
                    calendarDate: calendarDateState
                }
            })
        }
        onLayoutHeight()
        window.addEventListener('resize', onLayoutHeight);
    })

    const onLayoutHeight = () => {
        const calendarCol = document.getElementsByClassName("calendarCol")
        const buttonCol = document.getElementsByClassName("buttonCol")
        const navCol = document.getElementsByClassName('nav')
        const reservationRoomList = document.getElementsByClassName("reservation-room-list")
        if (calendarCol[0] && buttonCol[0] && navCol[0] && reservationRoomList[0]) {
            let calendar = calendarCol[0].offsetHeight
            let button = buttonCol[0].offsetHeight
            let nav = navCol[0].offsetHeight
            let reservation = reservationRoomList[0]
            const roomList = window.innerHeight - (calendar + button + nav)
            reservation.style.height = `${roomList - 20}px`
        }
    }

    const onReservation = () => {
        dispatch(checkTokenExpire)
        setReservation({
            visible: true,
            action: 'create'
        })
    }

    const onJoinVroom = () => {
        dispatch(checkTokenExpire)
        setJointVroom(!jointVroom)
    }

    const tileContent = ({ date, view }) => {
        const reservationDate = reservationList.map(item => {
            return item.start_dt
        })
        let html = []
        let i = 0;
        for (const bookingDate of reservationDate) {
            const classResponse = date.getDate() < 10 ? 'calendarBook' : 'calendarBookMulti'
            if ((view === 'month' && moment(date).format("DMYYYY")) === (moment(bookingDate).format("DMYYYY"))) {
                html.push(<span key={i} className={classResponse}>{date.getDate()}</span>)
            }
            i++
        }
        return html
    }

    const onShowReservationRoom = () => {
        const response = reservationItems.map((item, index) => {
            const startDate = moment(item.start_dt).format('D/MMM/YYYY/HH:mm').split('/')
            const endDate = moment(item.end_dt).format('D/MMM/YYYY/HH:mm').split('/')
            return (<div
                key={index}
                onClick={onSetRoomId.bind(this, item.id)}
                className={item.id === activeItem ? "reservation-room-list-item-active" : "reservation-room-list-item"}
            >
                <div>
                    <label>{startDate[0]}</label>
                    <label>{startDate[1]}</label>
                </div>
                <div>
                    <label>{item.name}</label>
                    <span>{startDate[3]}-{endDate[3]}</span>
                </div>
            </div>)
        })
        return response
    }

    const onSetRoomId = (id) => {
        dispatch({
            type: SET_RESERVATION,
            payload: { activeItem: id }
        })
    }

    const onChangeDay = (date) => {
        const selectDay = moment(date).format('D/MM/Y')
        const afterDate = getDateCurrent(date);
        setcalendarSelect(afterDate)
        dispatch({
            type: GET_ROOM_DAY,
            payload: {
                selectDay
            }
        })
        setTimeout(() => {
            const reservationRoomList = document.getElementsByClassName("reservation-room-list-item-active")[0]
            if (reservationRoomList)
                reservationRoomList.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }, 300)
    }

    const onChangeMouth = ({ date, label }) => {
        const dateConvert = moment(date).format('MM/Y')
        const startDate = Date.parse(moment(date).startOf('month').subtract(7, 'day').format('M/D/Y'));
        const endDate = Date.parse(moment(date).endOf('month').add(7, 'day').format('M/D/Y'));
        if (dateConvert !== calendarDate) {
            setTimeout(() => {
                setCalendarDateState(dateConvert)
            })
            dispatch({
                type: GET_RESERVATION,
                payload: {
                    startDate,
                    endDate
                }
            })
        }
        return label
    }

    const getDateCurrent = (date) => {
        const selectDate = moment(date).format('YYYY-MM-DD')
        const currentDate = moment().format('YYYY-MM-DD')
        if (!moment(selectDate).isAfter(currentDate)) {
            return moment(moment().format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm')
        } else {
            return moment(moment(date).format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm')
        }
    }

    return (
        <Col xl={6} lg={8} md={10} sm={24} xs={24} className="reservation-left">
            <div className="calendarCol">
                <label>{t("reservation_calendar")}</label>
                <Calendar
                    calendarType="US"
                    locale={language === 'cn' ? `zh-${language}` : language}
                    tileContent={tileContent}
                    onClickDay={onChangeDay.bind(this)}
                    navigationLabel={onChangeMouth.bind(this)}
                />
            </div>
            <div className="buttonCol">
                <Row type="flex" justify="center">
                    <Col span={18}>
                        <Button onClick={onReservation}>{t("reservation_button_room_meeting")}</Button>
                        <Button onClick={onJoinVroom}>{t("reservation_button_join_room")}</Button>
                    </Col>
                </Row>
            </div>
            <div className="reservation-room-list">
                <Row type="flex" justify="center">
                    <Col span={22}>
                        {onShowReservationRoom()}
                    </Col>
                </Row>
            </div>
            <ModalReservationVroom
                visible={createReservation.visible}
                title={t("reservation_modal_form.header")}
                setReservation={setReservation}
                action={createReservation.action}
                calendarSelect={calendarSelect}
            />
            <ModalJoinVroom
                visible={jointVroom}
                title={t("reservation_modal_join.header")}
                setJointVroom={setJointVroom}
            />
        </Col>
    )
}

export default translate()(ContentLeft)